import { useEffect } from 'react';
import { GoogleReview } from '../../vanillaComponent/google-review.ts';

function GoogleReviewWidget() {
  useEffect(() => {
    const widgetData = {
      customSwiperClassName: 'custom-swiper-name',
      customModalClassName: 'custom-modal-name',
      placeId: 'ChIJKevKMWfxLogRQCJLiQ4EfWQ',
      maxLimit: 10,
      ratingValue: 3,
      primaryColor: 'orange',
    };

    const sliderModule = new GoogleReview(widgetData);
    sliderModule.init('search-container');

    // If you need to clean up or perform actions when the component is unmounted,
    // you can return a cleanup function from the useEffect.
    return () => {
      // Cleanup logic (if needed)
    };
  }, []); // Empty dependency array means this effect runs only once

  return (
    <>
      <div id='search-container' className='container'>
        {/* No need for an extra div here */}
      </div>

      <iframe
        title='Example HTML'
        src='/htmlPages/google_review.html'
        style={{ paddingTop: '50px', border: 'none' }}
        width='100%'
        height='740px'
      ></iframe>
    </>
  );
}

export default GoogleReviewWidget;
